module.exports = __webpack_public_path__ + "static/img/p-1.91671ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-1.png
// module id = wxAU
// module chunks = 0